import { postApi } from "./api-utils";

// These legacy request/notification APIs do not have v4 equivalents in
// API_V1_V4_FRONTEND.md yet. Keep them isolated here so UI code is not coupled
// to v1 paths and can switch to v4 by changing this service only.
const legacyRequestEndpoints = {
  confirmOrReject: "api/v1/ma/confirm-or-reject",
  continueRequest: "api/v1/ma/continue-requests",
  deleteRequest: "api/v1/ma/delete-request",
  extractQr: "api/v1/ma/extract-qr",
  finishRequest: "api/v1/ma/finished-requests",
  makeRequest: "api/v1/ma/make-request",
  requestDetail: "api/v1/ma/get-noti-detail",
  userAssigned: "api/v1/ma/get-user-assigned",
  userRequests: "api/v1/ma/get-user-requests",
};

const legacyNotificationEndpoints = {
  clickRead: "api/v1/ma/click-read-noti",
  count: "api/v1/ma/get-count-noti",
  list: "api/v1/ma/get-user-noti",
  sendAll: "api/v1/tool/send-noti-to-all",
};

export const getRequestList = ({ username, assigned = false }) => {
  return postApi(assigned ? legacyRequestEndpoints.userAssigned : legacyRequestEndpoints.userRequests, {
    user: username,
  });
};

export const getRequestDetail = (requestId) => {
  return postApi(legacyRequestEndpoints.requestDetail, { request_id: requestId });
};

export const createRequest = ({ author, assignee, requestType, devices, advanced }) => {
  return postApi(legacyRequestEndpoints.makeRequest, {
    author,
    assignee,
    request_type: requestType,
    devices,
    advanced,
  });
};

export const deleteRequest = (requestId) => {
  return postApi(legacyRequestEndpoints.deleteRequest, { request_id: requestId });
};

export const confirmOrRejectRequest = ({ requestId, isConfirm, metadata }) => {
  return postApi(legacyRequestEndpoints.confirmOrReject, {
    request_id: requestId,
    is_confirm: isConfirm,
    metadata,
  });
};

export const continueRequest = ({ requestId, isContinueType0, advanced }) => {
  return postApi(legacyRequestEndpoints.continueRequest, {
    request_id: requestId,
    is_continue_type_0: isContinueType0,
    advanced,
  });
};

export const finishRequest = ({ requestId, isFinishedType0, advanced }) => {
  return postApi(legacyRequestEndpoints.finishRequest, {
    request_id: requestId,
    is_finished_type_0: isFinishedType0,
    advanced,
  });
};

export const extractQr = (base64Images) => {
  return postApi(legacyRequestEndpoints.extractQr, { base64_imgs: base64Images });
};

export const getUserNotifications = (username) => {
  return postApi(legacyNotificationEndpoints.list, { user: username });
};

export const getUserNotificationCount = (username) => {
  return postApi(legacyNotificationEndpoints.count, { user: username });
};

export const markNotificationRead = (notificationId) => {
  return postApi(legacyNotificationEndpoints.clickRead, { noti_id: notificationId });
};

export const sendNotificationToAll = ({ title, body }) => {
  return postApi(legacyNotificationEndpoints.sendAll, { title, body });
};
